import { forwardRef, Ref, type SVGProps } from 'react';

const SvgBusinessIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 27 33"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" clipPath="url(#business-icon_svg__a)">
      <path d="M26.989 5.936H0V15.8l8.275 3.496H0v9.723c0 1.809.909 3.335 2.153 3.82q.404.158.845.16H23.99q.441-.002.845-.16c1.245-.485 2.154-2.011 2.154-3.82v-9.723h-8.517l8.517-3.599zM16.845 19.297a3.35 3.35 0 1 1-6.702 0z" />
      <path d="M19.506 5.935a6 6 0 0 0-2.465-4.778A6 6 0 0 0 13.494 0c-1.326 0-2.552.43-3.547 1.157a6 6 0 0 0-2.465 4.778v.077h12.025v-.077zm-8.393 0a2.383 2.383 0 0 1 4.762 0z" />
    </g>
    <defs>
      <clipPath id="business-icon_svg__a">
        <path fill="currentColor" d="M0 0h26.989v33H0z" />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgBusinessIcon);
export default ForwardRef;
